import { normalizeDate, normalizedTimesByDate as buildNormalizedTimesByDate } from './edit_form_time_section_utils';

/**
 * Populate lockbox time dropdown from timesByDate for the selected date; update heading and submit info.
 * callbacks: { updateLockboxHeadingMeta(), updateSubmitInfo() }
 */
export function updateLockboxTimeOptions(section, elements, callbacks = {}) {
  const { lockboxDateSelect, lockboxTimeSelect, lockboxWrap } = elements;
  const { updateLockboxHeadingMeta, updateSubmitInfo } = callbacks;

  if (!lockboxDateSelect || !lockboxTimeSelect || !lockboxWrap) return;
  const timesByDateRaw = JSON.parse(lockboxWrap.dataset.timesByDate || '{}');
  const selectedDate = (lockboxDateSelect.value || '').trim();
  const previousTime = lockboxTimeSelect.value || lockboxTimeSelect.dataset.selectedTime || '';

  const byDate = buildNormalizedTimesByDate(timesByDateRaw);
  const selectedDateKey = normalizeDate(selectedDate);
  const times = selectedDateKey ? (byDate[selectedDateKey] || []) : [];

  lockboxTimeSelect.innerHTML = '';
  const blankOption = document.createElement('option');
  blankOption.value = '';
  blankOption.textContent = 'Select time';
  lockboxTimeSelect.appendChild(blankOption);

  times.forEach((time) => {
    const option = document.createElement('option');
    option.value = time;
    option.textContent = time === 'NOW' ? 'Now' : time;
    lockboxTimeSelect.appendChild(option);
  });

  if (previousTime && times.includes(previousTime)) {
    lockboxTimeSelect.value = previousTime;
  } else {
    lockboxTimeSelect.value = '';
  }
  lockboxTimeSelect.dataset.selectedTime = '';
  updateLockboxHeadingMeta?.();
  updateSubmitInfo?.();
}

/**
 * Sync the hidden lockbox showtime input from date + time selects; clear available-slots value; update submit info.
 * callbacks: { updateSubmitInfo() }
 */
export function syncLockboxHiddenValue(elements, callbacks = {}) {
  const { lockboxShowtimeInput, lockboxDateSelect, lockboxTimeSelect, selectedInput } = elements;
  const { updateSubmitInfo } = callbacks;

  if (!lockboxShowtimeInput || !lockboxDateSelect || !lockboxTimeSelect) return;
  const date = lockboxDateSelect.value;
  const time = lockboxTimeSelect.value;
  if (!date || !time) {
    lockboxShowtimeInput.value = '';
    updateSubmitInfo?.();
    return;
  }
  lockboxShowtimeInput.value = time === 'NOW' ? 'NOW' : `${date} ${time}`;
  if (selectedInput) {
    selectedInput.value = '';
  }
  updateSubmitInfo?.();
}

/**
 * Create bound lockbox handlers (no-arg functions) for use in syncMode and init.
 * Returns { updateLockboxTimeOptions, syncLockboxHiddenValue }.
 */
export function createLockboxHandlers(section, elements, callbacks) {
  return {
    updateLockboxTimeOptions: () => updateLockboxTimeOptions(section, elements, callbacks),
    syncLockboxHiddenValue: () => syncLockboxHiddenValue(elements, callbacks)
  };
}

/**
 * Bind change/input listeners for lockbox date and time selects.
 * lockboxHandlers: { updateLockboxTimeOptions(), syncLockboxHiddenValue() } from createLockboxHandlers.
 */
export function initLockboxListeners(section, elements, lockboxHandlers) {
  const { lockboxDateSelect, lockboxTimeSelect } = elements;
  const { updateLockboxTimeOptions, syncLockboxHiddenValue } = lockboxHandlers;

  if (lockboxDateSelect && lockboxDateSelect.dataset.bound !== 'true') {
    lockboxDateSelect.dataset.bound = 'true';
    const onLockboxDateChange = () => {
      updateLockboxTimeOptions();
      syncLockboxHiddenValue();
    };
    lockboxDateSelect.addEventListener('change', onLockboxDateChange);
    lockboxDateSelect.addEventListener('input', onLockboxDateChange);
  }

  if (lockboxTimeSelect && lockboxTimeSelect.dataset.bound !== 'true') {
    lockboxTimeSelect.dataset.bound = 'true';
    lockboxTimeSelect.addEventListener('change', syncLockboxHiddenValue);
  }
}
